export const API_BASE_URL = "https://backend.chseexpress.com";
